import React from "react";
import {ProfileView} from "components/users";
import API, {IMAGE_URL} from "config/Api";
import axios from "axios";
import {userDetailType} from "types";
import {Helmet} from "react-helmet-async";
import ReactGA from "react-ga";
import {useParams, useNavigate} from 'react-router-dom';
import {Loading} from "../components/ui";
// import { subscribeToTopic } from "../firebase";

export default function Home() {
    const [userDetails, setUserDetails] = React.useState<userDetailType | any>(
        null
    );
    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const {userName} = useParams();
    let navigate = useNavigate();

    const fetchUserDetail = React.useCallback(() => {
        const url = API + `viewprofile`;
        const config = {
            params: {
                username: userName,
            },
        };
        axios
            .get(url, config)
            .then((response) => {
                ReactGA.initialize("UA-210740501-1");
                ReactGA.event({
                    category: "Links Share",
                    action: "Links Share",
                    label: "Links Share",
                    value: 1,
                });
                if (response.data.success) {
                    setUserDetails(response.data.data);
                    setIsLoading(false);
                    // const topic = response.data.data.id + "_topic"
                    // subscribeToTopic(topic);
                } else {
                    navigate(`*`);
                }
            })
            .catch((err: { response: any }) => {
                console.log("error here", err);
                navigate(`*`);
            });
    }, [userName]);

    React.useEffect(() => {
        fetchUserDetail();
    }, [fetchUserDetail]);

    if (isLoading) {
        return <Loading/>
    }

    return (
        <>
            <Helmet>
                <title>
                    {`jod-e | ${userDetails?.profile_name || userDetails?.username}`}
                </title>
                <meta
                    name="description"
                    content="Introduce yourself with a jod-e digital card."
                />
                {/* <meta
          name="description"
          content={`${userDetails?.profile_name || userDetails?.username}' ${
            userDetails?.bio
          } @Jode-E`}
        /> */}
                <link rel="icon" href={`${IMAGE_URL}${userDetails?.profile_pic}` || `/favicon.ico`}/>
                <link
                    rel="apple-touch-icon"
                    href={`${IMAGE_URL}${userDetails?.profile_pic}` || `/favicon.ico`}
                />
                <link
                    rel="manifest"
                    href={`${IMAGE_URL}${userDetails?.profile_pic}` || `/favicon.ico`}
                />
            </Helmet>

            <section
                className="fixed inset-0"
                style={{
                    backgroundImage: `url(${IMAGE_URL}${userDetails?.background_pic})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div
                    className={`${
                        userDetails?.background_pic === ""
                            ? "mx-auto h-full overflow-auto bg-white scrollbar-hide sm:max-w-3xl sm:shadow-2xl"
                            : "mx-auto h-full overflow-auto border-x border-x-white/20 bg-white/10 backdrop-blur-md scrollbar-hide sm:max-w-3xl"
                    }`}
                >
                    <ProfileView userData={userDetails}/>
                </div>
            </section>
        </>
    );
}
